import React from 'react';
import PropTypes, { bool, objectOf } from 'prop-types';
import './productDescription.scss';

export const ProductDescription = ({ product, disableLink }) => {
  const canonicalUrl = product?.identifiers?.canonicalUrl;
  const brandName = product?.identifiers?.brandName;
  const productLabel = product?.identifiers?.productLabel;
  return (
    disableLink ?
      (
        <div className="pod-description">
          <span className="pod-description__brand-name">
            {brandName}
          </span>
          <span>{productLabel}</span>
        </div>
      )
      :
      (
        <a href={canonicalUrl}>
          <div className="pod-description">
            <span className="pod-description__brand-name">
              <b>{brandName}</b>
            </span>
            <span>{productLabel}</span>
          </div>
        </a>
      )
  );
};

ProductDescription.propTypes = {
  /* eslint-disable-next-line react/forbid-prop-types */
  product: objectOf(PropTypes.any).isRequired,
  disableLink: bool
};

ProductDescription.defaultProps = {
  disableLink: false
};

ProductDescription.displayName = 'ProductDescription';